// extracted by mini-css-extract-plugin
export default {"container":"container---IcEgN","loader":"loader---CNfl7","spinloader":"spinloader---RKflF","spinlogo":"spinlogo---r5E45"};